import { memo } from "react";
import { ValueCell } from "@tools";

export const CompanyUnitCostCell = memo((cellProps) => (
  <ValueCell size="large" { ...cellProps} />
));